import React from "react";
import { Temporal } from "@js-temporal/polyfill";

import { ReactComponent as ArrowDownIcon } from "images/icons/arrow-down-1.svg?react";
import { ReactComponent as TimeClockCircleIcon } from "images/icons/time-clock-circle.svg?react";
import { FulfillmentMethod } from "../types/catalog";

const FulfillmentTimeSelector = ({
  selectedTime,
  fulfillmentMethod,
  fulfillmentTimeOptions
}: {
  selectedTime: Temporal.ZonedDateTime | null;
  fulfillmentMethod: FulfillmentMethod;
  fulfillmentTimeOptions: Array<Temporal.ZonedDateTime>;
}) : React.JSX.Element => {
  const timeOptions = fulfillmentTimeOptions.map(t => {
    const opts : Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "numeric",
    };

    const right = t.toLocaleString("en-NZ", opts);
    const left = (t.subtract({ minutes: 10 })).toLocaleString("en-NZ", opts);

    switch (fulfillmentMethod) {
      case "delivery":
        return (<option value={t.toString()} key={t.toString()}>{left} - {right}</option>);

      case "pickup":
        return (<option value={t.toString()} key={t.toString()}>{right}</option>);
    }
  });

  return (
    <div className="select has-prefix-icon has-end-icon space-mb-none">
      <label htmlFor="overlay_delivery_time">Time</label>
      <span>
        <TimeClockCircleIcon className="icon streamline-icon" />

        <select name="delivery_time" id="delivery_time" defaultValue={selectedTime?.toString()}>
          <option value="ASAP">ASAP</option>

          {timeOptions}
        </select>

        <ArrowDownIcon className="icon streamline-icon" />
      </span>
    </div>
  );
}

export { FulfillmentTimeSelector };
